var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlowingMapLofi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 114,
    viewBox: "0 0 114 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9,
    filter: "url(#filter0_f_2637_3147)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 57,
    cy: 57,
    r: 17,
    fill: "#FE60A2"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2637_3147)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-2-outside-1_2637_3147",
    maskUnits: "userSpaceOnUse",
    x: 40,
    y: 40,
    width: 33,
    height: 34,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 40,
    y: 40,
    width: 33,
    height: 34
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7281 57.0316C66.8487 57.1133 64.9693 56.7864 63.3351 55.8876C64.8059 53.1911 65.7865 50.1677 65.2145 47.0627C64.9693 45.3467 63.9888 43.9576 62.518 42.8954C61.2106 41.9965 59.658 41.6697 58.2689 42.4051C57.6152 42.8137 57.125 43.5491 57.125 44.2845C56.9615 46.4907 56.9615 48.6969 55.8993 50.658C53.2028 49.2689 50.1794 48.2067 47.0744 48.7786C44.051 49.2689 41.2728 52.1288 42.1717 55.3156C42.1717 55.3973 42.3351 55.3973 42.3351 55.479C42.6619 56.623 43.9693 56.8681 45.0316 57.0316C46.9927 56.7047 48.8721 57.3584 50.6697 58.0938C49.444 60.3001 48.7086 62.7514 48.5452 65.2028C48.4635 66.5919 48.7903 67.981 49.6075 69.2067C49.7709 69.3701 49.8526 69.5335 50.016 69.7787C51.2417 71.2495 53.1211 72.4752 55.0822 71.8215C55.1639 71.8215 55.2456 71.8215 55.3273 71.8215C56.2261 71.3312 56.9615 70.5141 56.9615 69.4518C56.9615 67.3273 57.125 65.2028 58.1055 63.3234C59.0043 63.8954 59.9849 64.3039 60.9654 64.6308C61.2923 64.7125 61.5374 64.7125 61.8643 64.8759C62.0277 64.9576 62.1911 64.9576 62.3545 64.9576C62.518 65.0394 62.5997 65.0394 62.7631 65.1211C64.8876 65.6113 67.0121 65.6931 68.8915 64.5491C70.6892 63.4868 72.0783 61.6892 71.9966 59.5646C71.9149 57.9304 70.2806 56.7864 68.7281 57.0316Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M68.7281 57.0316C66.8487 57.1133 64.9693 56.7864 63.3351 55.8876C64.8059 53.1911 65.7865 50.1677 65.2145 47.0627C64.9693 45.3467 63.9888 43.9576 62.518 42.8954C61.2106 41.9965 59.658 41.6697 58.2689 42.4051C57.6152 42.8137 57.125 43.5491 57.125 44.2845C56.9615 46.4907 56.9615 48.6969 55.8993 50.658C53.2028 49.2689 50.1794 48.2067 47.0744 48.7786C44.051 49.2689 41.2728 52.1288 42.1717 55.3156C42.1717 55.3973 42.3351 55.3973 42.3351 55.479C42.6619 56.623 43.9693 56.8681 45.0316 57.0316C46.9927 56.7047 48.8721 57.3584 50.6697 58.0938C49.444 60.3001 48.7086 62.7514 48.5452 65.2028C48.4635 66.5919 48.7903 67.981 49.6075 69.2067C49.7709 69.3701 49.8526 69.5335 50.016 69.7787C51.2417 71.2495 53.1211 72.4752 55.0822 71.8215C55.1639 71.8215 55.2456 71.8215 55.3273 71.8215C56.2261 71.3312 56.9615 70.5141 56.9615 69.4518C56.9615 67.3273 57.125 65.2028 58.1055 63.3234C59.0043 63.8954 59.9849 64.3039 60.9654 64.6308C61.2923 64.7125 61.5374 64.7125 61.8643 64.8759C62.0277 64.9576 62.1911 64.9576 62.3545 64.9576C62.518 65.0394 62.5997 65.0394 62.7631 65.1211C64.8876 65.6113 67.0121 65.6931 68.8915 64.5491C70.6892 63.4868 72.0783 61.6892 71.9966 59.5646C71.9149 57.9304 70.2806 56.7864 68.7281 57.0316Z",
    fill: "#FE60A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7281 57.0316C66.8487 57.1133 64.9693 56.7864 63.3351 55.8876C64.8059 53.1911 65.7865 50.1677 65.2145 47.0627C64.9693 45.3467 63.9888 43.9576 62.518 42.8954C61.2106 41.9965 59.658 41.6697 58.2689 42.4051C57.6152 42.8137 57.125 43.5491 57.125 44.2845C56.9615 46.4907 56.9615 48.6969 55.8993 50.658C53.2028 49.2689 50.1794 48.2067 47.0744 48.7786C44.051 49.2689 41.2728 52.1288 42.1717 55.3156C42.1717 55.3973 42.3351 55.3973 42.3351 55.479C42.6619 56.623 43.9693 56.8681 45.0316 57.0316C46.9927 56.7047 48.8721 57.3584 50.6697 58.0938C49.444 60.3001 48.7086 62.7514 48.5452 65.2028C48.4635 66.5919 48.7903 67.981 49.6075 69.2067C49.7709 69.3701 49.8526 69.5335 50.016 69.7787C51.2417 71.2495 53.1211 72.4752 55.0822 71.8215C55.1639 71.8215 55.2456 71.8215 55.3273 71.8215C56.2261 71.3312 56.9615 70.5141 56.9615 69.4518C56.9615 67.3273 57.125 65.2028 58.1055 63.3234C59.0043 63.8954 59.9849 64.3039 60.9654 64.6308C61.2923 64.7125 61.5374 64.7125 61.8643 64.8759C62.0277 64.9576 62.1911 64.9576 62.3545 64.9576C62.518 65.0394 62.5997 65.0394 62.7631 65.1211C64.8876 65.6113 67.0121 65.6931 68.8915 64.5491C70.6892 63.4868 72.0783 61.6892 71.9966 59.5646C71.9149 57.9304 70.2806 56.7864 68.7281 57.0316Z",
    stroke: "#232323",
    strokeWidth: 2,
    mask: "url(#path-2-outside-1_2637_3147)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2637_3147",
    x: 0,
    y: 0,
    width: 114,
    height: 114,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20,
    result: "effect1_foregroundBlur_2637_3147"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2637_3147",
    x: 36.9995,
    y: 40.9989,
    width: 40.0005,
    height: 40.0063,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2637_3147"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2637_3147",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlowingMapLofi);
export default __webpack_public_path__ + "static/media/glowing_map_lofi.6a3ec955481e33ea9b93809e50c5fa84.svg";
export { ForwardRef as ReactComponent };